// extracted by mini-css-extract-plugin
export var activeFilterButton = "_op-c";
export var backButton = "_op-4";
export var backIcon = "_op-5";
export var chevronShortcut = "_op-6";
export var container = "_op-1";
export var editor = "_op-8";
export var editorWrapper = "_op-7";
export var prefix = "_op-2";
export var searchIcon = "_op-3";
export var suffix = "_op-9";
export var suffixContent = "_op-a";
export var suffixText = "_op-b";
export var wrapper = "_op-0";